<template>
  <v-form v-model="valid" ref="form">
    <v-card>
      <v-card-title>
        {{ $t("emailForm.title") }}
      </v-card-title>

      <v-card-text>
        <v-text-field
          :label="$t('emailForm.subject.label')"
          :rules="[(v) => (v && v.length > 3) || $t('validation.required')]"
          v-model="formData.subject"
          color="secondary"
        ></v-text-field>

        <v-textarea
          :label="$t('emailForm.text.label')"
          :rules="[(v) => (v && v.length > 10) || $t('validation.required')]"
          v-model="formData.text"
          color="secondary"
          auto-grow
        ></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-dialog v-model="dialog" persistent max-width="600">
          <template #activator="{ on, attrs }">
            <v-btn :disabled="!valid" color="secondary" v-bind="attrs" v-on="on">
              {{ $t("emailForm.send") }}
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="headline">
              {{ $t("emailForm.confirmation.title") }}
            </v-card-title>

            <v-card-text>
              <Markdown :value="$t('emailForm.confirmation.description')" />
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="dialog = false">
                {{ $t("emailForm.confirmation.cancel") }}
              </v-btn>

              <v-btn color="primary" @click="send" :loading="loading">
                {{ $t("emailForm.confirmation.accept") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="sent" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.sent") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import EmailUserMutation from "@/gql/mutations/EmailUserMutation.gql";

export default {
  components: {},

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        subject: "",
        text: "",
      },
      dialog: false,
      loading: false,
      valid: false,
      sent: false,
    };
  },

  methods: {
    async send() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: EmailUserMutation,
        variables: {
          userId: this.user.id,
          subject: this.formData.subject,
          text: this.formData.text,
        },
      });

      this.$refs.form.reset();

      this.sent = true;
      this.dialog = false;
      this.loading = false;
    },
  },
};
</script>
